<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">Додати інформацію</h2>
    </v-card-title>

    <v-card-content>
      <div class="mb-3">
        <v-text-field
          :focus="true"
          v-model="form.name"
          :label="'Інформація про модель'"
          :hint="errorMessage('name')"
          :invalid="!!errorMessage('name')"
        />
      </div>
      <div class="mb-3">
        <v-text-field
          v-model="form.calibration"
          :label="'Калібрування'"
          :hint="errorMessage('calibration')"
          :invalid="!!errorMessage('calibration')"
        />
      </div>
    </v-card-content>

    <v-card-actions>
      <v-btn color="primary" :loading="loading" @click="onCreate">{{ 'base.add' | translate }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'AddCalibrationModal',
  mixins: [formErrorsMixin],
  data () {
    return {
      form: {
        name: '',
        calibration: ''
      },
      errors: {
        name: null,
        calibration: null
      },
      loading: false
    }
  },

  methods: {
    async onCreate () {
      this.loading = true

      this.checkValidData()

      await new Promise(resolve => setTimeout(resolve, 300))
      if (this.errors.name === null && this.errors.calibration === null) {
        const calibrationData = {
          name: this.form.name.trim(),
          calibration: this.form.calibration.trim()
        }
        this.$emit('create', calibrationData)
        this.$emit('close')
      }

      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      this.errors.calibration = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
      if (!this.form.calibration) {
        this.errors.calibration = ['3']
      }
    }
  }
}
</script>
